import { useState, useEffect } from 'react';
import Header from '../../Components/Header/Header';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import Buttons from '../../Components/Buttons/Buttons';
import PopCheck from '../../Images/PopCheck.png';
import { useApi } from '../../Services/api';
import { useGlobalState } from '../../Contexts/GlobalStateContext';
import Popup from '../../Components/Popup/Popup';
import { useNavigate } from 'react-router-dom';
import './MemberSignup.css'

const MemberCreate = () => {
  const [paramValue, setParamValue] = useState(null);
  const [validated, setValidated] = useState(false);
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const { setErrorVisible, setErrorMessage, setVoyceToken, setRemember } = useGlobalState();
  const navigate = useNavigate();
  const api = useApi();

  useEffect(() => {
    const param = new URLSearchParams(window.location.search).get('InvitationCode');
    if (param) {
      const checkParam = async () => {
        try {
          const body = {
            InvitationCode: param
          };
          const raw = await api.post('Client/ValidInvitationCode', body);
          const paramData = raw.data;
  
          if (!paramData.Success) {
            setParamValue("invalid");
          } else {
            setParamValue(param);
            setEmail(paramData.Email);
            setFirstName(paramData.FirstName);
            setLastName(paramData.LastName);
          }
        } catch (error) {
          console.log('error:', error);
          setParamValue("invalid");
        }
      };
  
      checkParam();
    } else {
      setParamValue("invalid");
    }
  }, []);
  

  const handleSubmit = (event) => {
    event.preventDefault();
    setValidated(true);

    let check = true;
    if (!confirmPassword) {
      setConfirmPasswordError('required field');
    } else if (confirmPassword !== password) {
      setConfirmPasswordError('passwords do not match!');
    } else {
      setConfirmPasswordError('');
      check = false;
    }

    

    const form = event.currentTarget;
    if (form.checkValidity() === false || !firstName || !lastName || !password || !confirmPassword || check) {
      event.stopPropagation();
      return;
    }
    const createAccount = async () => {
      try {
        const body = {
          InvitationCode: paramValue,
          FirstName: firstName,
          LastName: lastName,
          Pwd: password,
          ConfirmedPwd: confirmPassword
        }
        const raw = await api.post('Client/ActiveUser', body);
        console.log(raw);
        const createData = raw.data;
        if (createData.Success === false) {
          setErrorVisible(true);
          setErrorMessage(createData.Error);
          return;
        }
        // popup, and redirect to login page
        setShowSuccessPopup(true);
      } catch (error) {
        console.log('error:', error);
      }
    }

    createAccount();
  }

  const handleSuccess = async () => {
    try {
      navigate('/Login');
    } catch (error) {
      console.log('error:', error);
    }
  }

  if (paramValue === "invalid") {
    return (
      <>
        <Header />
        <div className='form-container'>
          <h1>Error</h1>
          <p>Please have your administrator send another invite.</p>
          <p>If the issue persists, please contact our support.</p>
        </div>
      </>
    );
  }
  if (!paramValue) {
    return (
      <>
        <Header />
        <div className='form-container'>
        </div>
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="form-container">
        <h1>Activate your account</h1>
        <Form className='form-content' noValidate validated={validated} onSubmit={handleSubmit}>
          <Form.Group controlId="validationCustom01">
            <div className='form-group-inline'>
              <Form.Label>Email</Form.Label>
            </div>
            <Form.Control
              required
              type="text"
              value={email}
              className="step-inputBox"
              disabled
            />
          </Form.Group>
          <Row className="step-row">
            <Form.Group as={Col} controlId="firstNameForm">
              <div className="form-group-inline">
                <Form.Label>First Name*</Form.Label>
                {validated && !firstName && <div className="invalid-feedback" style={{ display: 'block' }}>required field</div>}
              </div>
              <Form.Control
                required
                type="text"
                placeholder="Enter your first name"
                value={firstName}
                onChange={(e) => {
                  setFirstName(e.target.value);
                }}
                className="step-inputBox"
              />
            </Form.Group>

            <Form.Group as={Col} controlId="lastNameForm">
              <div className="form-group-inline">
                <Form.Label>Last Name*</Form.Label>
                {validated && !lastName && <div className="invalid-feedback" style={{ display: 'block' }}>required field</div>}
              </div>
              <Form.Control
                required
                type="text"
                placeholder="Enter your last name"
                value={lastName}
                onChange={(e) => {
                  setLastName(e.target.value);
                }}
                className="step-inputBox"
              />
            </Form.Group>
          </Row>
          <Row className="step-row">
            <Form.Group as={Col} controlId="passwordForm">
              <div className="form-group-inline">
                <Form.Label>Password*</Form.Label>
                {validated && !password && <div className="invalid-feedback" style={{ display: 'block' }}>required field</div>}
              </div>
              <Form.Control
                required
                type="password"
                placeholder="Create your password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
                className="step-inputBox"
              />
            </Form.Group>
            <Form.Group as={Col} controlId="confirmPasswordForm">
              <div className="form-group-inline">
                <Form.Label>Confirm Password*</Form.Label>
                {validated && confirmPasswordError && <div className="invalid-feedback" style={{ display: 'block' }}>{confirmPasswordError}</div>}
              </div>
              <Form.Control
                required
                type="password"
                placeholder="Confirm your password"
                value={confirmPassword}
                onChange={(e) => {
                  setConfirmPassword(e.target.value);
                  if (e.target.value) setConfirmPasswordError('');
                }}
                className="step-inputBox"
              />
            </Form.Group>
          </Row>
          <Buttons/>
        </Form>
        {showSuccessPopup && (
            <Popup
              show={showSuccessPopup}
              handleClose={handleSuccess}
         
              title={
                <>
                  <img src={PopCheck} className="PaymentPage-success-pop-image" alt="Verification" />
                  <div>Account created successfully</div>
                </>
              }
              titleStyle="popup-title"
              body="Thank you for choosing Voyce as your Interpretation Service Provider"
              bodyStyle="popup-body"
              footer={
                <Buttons className='btn-done'  handleSubmit={handleSuccess} text={"Login"} CardElement='payment-element' />
              }
              footerStyle="popup-footer"
            />
          )}
      </div>
    </>
    
  );
};

export default MemberCreate;